(function () {
  function addBusinessDays(date, days) {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var remaining = Math.max(0, Number(days) || 0);

    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) remaining -= 1;
    }

    return result;
  }

  function renderDeliveryDates(root) {
    root.querySelectorAll('[data-levano-delivery-date]').forEach(function (element) {
      var deliveryDate = addBusinessDays(new Date(), element.dataset.businessDays);
      var locale = document.documentElement.lang || 'en';
      element.textContent = new Intl.DateTimeFormat(locale, {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      }).format(deliveryDate);
    });
  }

  function updatePercentageSaving(root, variant) {
    var saving = root.querySelector('[data-levano-save-price]');
    if (!saving || !variant) return;

    if (variant.compare_at_price > variant.price) {
      var percentage = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
      saving.textContent = saving.dataset.label.replace('[saved_amount]', percentage + '%');
      saving.classList.remove('hide');
    } else {
      saving.classList.add('hide');
    }
  }

  function init(root) {
    if (root.dataset.levanoInitialized === 'true') return;
    root.dataset.levanoInitialized = 'true';
    renderDeliveryDates(root);
    root.addEventListener('variantPriceChange', function (event) {
      window.requestAnimationFrame(function () {
        updatePercentageSaving(root, event.detail && event.detail.variant);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-levano-product]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
